var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector56(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 309,
    viewBox: "0 0 64 309",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M328.544 307.548C305.155 288.633 301.449 284.514 286.633 265.105C283.002 260.35 277.291 251.106 271.836 239.689C270.201 236.272 268.719 232.884 267.36 229.543C257.666 205.636 256.297 178.853 258.55 152.402C264.299 84.9127 227.768 24.0008 172.457 6.24348C117.05 -11.5423 55.5241 17.7179 25.5022 63.3781C21.5962 69.3193 4.36619 97.3552 1.81922 128.115C-6.24934 225.234 87.8269 264.042 230.97 293.426C233.755 293.995 247.012 296.168 249.825 296.558L328.553 307.557L328.544 307.548Z",
    stroke: "#1E1E22",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector56);
export default __webpack_public_path__ + "static/media/vector5-6.4f078af0d80aa3de40591f717400bc30.svg";
export { ForwardRef as ReactComponent };